import { useMutation } from "react-query";
import updateRegtankLivenessReattemptApproval from "../services/updateRegtankLivenessReattemptApproval";

function useUpdateRegtankLivenessReattemptApproval() {
  return useMutation(
    ["updateRegtankLivenessReattemptApproval"],
    updateRegtankLivenessReattemptApproval
  );
}

export default useUpdateRegtankLivenessReattemptApproval;
